<template>
	<vs-list v-if="list.length > 0">
		<vs-list-item
			v-for="(listItem, index) in list"
			:title="resolveListItemTitle(listItem) | capitalize"
			class="list-item"
			:key="index"
		>
			<template slot="subtitle">
				<span class="text-sm mr-1"> {{ listItem.init_date }}, </span>

				<span class="text-sm ml-1"> {{ listItem.init_hour }} - {{ listItem.end_hour }}</span>
			</template>

			<vs-button
				color="danger"
				icon-pack="feather"
				icon="icon-trash-2"
				@click.stop="action('delete', index)"
				:title="$t('Crud.Delete')"
			></vs-button>
		</vs-list-item>
	</vs-list>
</template>
<script>
export default {
	props: {
		events: {
			type: Array,
			required: true,
		},
		action: {
			type: Function,
			required: false,
		},
	},
	data() {
		return {
			list: this.events,
			listSize: this.events.length,
		};
	},
	computed: {
		jobTypeTranslate() {
			return function (jobType = "PICKUP") {
				return jobType === "PICKUP"
					? this.$t("Waypoint.Pickup").toUpperCase()
					: this.$t("Waypoint.Delivery").toUpperCase();
			};
		},
		resolveListItemTitle() {
			return (listItem) => {
				return listItem.activity_name + " - " + listItem.visit_point_name;
			};
		},
	},
};
</script>
<style>
.list-item {
	transition: all 1s;
}
</style>
